module.exports = __webpack_public_path__ + "static/img/03.6bfabba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/03.png
// module id = RfAv
// module chunks = 1